<template>
  <v-footer
    id="app-footer"
    color="#E5E5E5"
    style="justify-content:center;color: #000000;text-align:center;"
    >{{ $t("footerText", [new Date().getFullYear()]) }}</v-footer
  >
</template>
<script lang="ts">
import Vue from "vue";
export default Vue.extend({});
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
* {
  font-size: 16px;
  line-height: 19px;
  @include fontSize(10, 16);
}
</style>
